// NOTE: this component will eventually be replaced by SecureConsent; requires AEM and CIAM changes
import * as React from 'react';
import styled from 'styled-components';
import { get, Link, Button, TextBody } from '@ally/metronome-ui';
import { LoginHeading } from '../../Layout/Layout';
const StyledUl = styled('ul') `
  padding-left: ${get.space('sm')};
`;
export const LegacyOBSA = ({ hostServices, onComplete, status, }) => {
    React.useEffect(() => {
        hostServices === null || hostServices === void 0 ? void 0 : hostServices.analytics.trackPageView({
            eventType: 'pageview',
            pageName: 'AOS:Login:Online Services Agreement',
        });
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(LoginHeading, { title: "Online Banking Services Agreement" }),
        React.createElement(TextBody, { size: "sm", tag: "p" },
            React.createElement(TextBody, { size: "sm", tag: "b" },
                "By selecting ",
                React.createElement("b", null, "Agree and Continue"),
                ", you agree:")),
        React.createElement(StyledUl, null,
            React.createElement(TextBody, { size: "sm", tag: "li" },
                "You've read and understood the\u00A0",
                React.createElement(Link, { text: "Ally Bank Online Banking Services Agreement", href: "https://www.ally.com/resources/pdf/bank/ally-bank-obsa.pdf", target: "_blank" }),
                "\u00A0(PDF), and you agree it governs your use of Ally Bank's online services"),
            React.createElement(TextBody, { size: "sm", tag: "li" }, "You've printed or downloaded a copy of the agreement for your records")),
        React.createElement(Button, { allytmln: "Agree and Continue", text: "Agree and Continue", onClick: onComplete, loading: status === 'Loading', mt: 2 })));
};
//# sourceMappingURL=LegacyOBSA.js.map